<template>
  <component :is="componentInstance"></component>
</template>
<script>
export default {
  computed: {
    componentInstance() {
      return () =>
        import(
          '@/views/WorkExperiences/infopages/' +
            this.$route.params.activity +
            '/' +
            this.$route.params.slug +
            '.vue'
        );
    },
  },
};
</script>
